import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className="App mt-5">Sorry Page Not Found !!!</h1>
        </div>
    );
};

export default NotFound;